'use client'

import animationData from '@/animation/splash-screen.json'
import { AnimatePresence, motion } from 'framer-motion'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

export default function SplashScreen() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    const timeout = setTimeout(() => {
      setIsLoading(false)
      document.body.style.overflow = 'auto'
    }, 4000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && (
          <motion.div
            key={'animation'}
            className="fixed top-0 z-50 w-full h-full bg-[#E2DBD8] flex justify-center items-center"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Lottie
              animationData={animationData}
              className=" w-[550px]"
              loop={true}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
